import React, { useContext, useEffect, useState } from 'react';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import JourneySteps from '../../components/IndividualLite/JourneySteps';
import BusinessPlusKYCStatus from '../../components/IndividualLite/BusinessPlusKYCStatus';
import { FORM_TYPE, STEPS } from '../../IPlushelper';
import { useNavigate } from 'react-router-dom';
import { doGET } from '../../../../../util/HttpUtil';
import { FaSpinner } from 'react-icons/fa';

const ThankYou = ({ applicationForm }) => {

    const { t } = useTranslation()
    const { showError } = useContext(DialogContext)
    const [allKYCComplete, setAllKYCComplete] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()

    const checkIfPendingPlusSteps = async () => {
        setLoading(true);
        try {
            const response = await doGET(`/api/application-form/detail?id=${applicationForm?.plus_id}&withExtension=true`);
            if (response?.status === 200 && response?.data) {
                const applicationFormStep =
                    response?.data?.steps?.find(v => v?.label == STEPS.APPLICATION_FORM)
                const documentStep = response?.data?.steps?.find(v => v?.label == STEPS.DOCUMENT_VERIFICATION)
                if ([0, 2]?.includes(applicationFormStep?.status) || [0, 2]?.includes(documentStep?.status)) {
                    navigate(`/business-plus/${response?.data?._id}`)
                }
            }
        } catch (error) {
            showError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (applicationForm?.plus_id) {
            checkIfPendingPlusSteps();
        } else {
            setLoading(false);
        }
    }, [applicationForm?.plus_id]);

    if (loading) {
        return <div className=" d-flex justify-content-center align-items-center flex-1">
            <FaSpinner size={20} className="spinner" />
        </div>
    }

    return (
        <div className='d-flex flex-column  justify-content-center  align-items-center  '>
            {applicationForm?.plus_id && !applicationForm?.cyclosUserId ? <>
                <JourneySteps
                    isKYCComplete={allKYCComplete}
                    type={"horizontal"}
                    formType={FORM_TYPE.BusinessPrime}
                />
                <BusinessPlusKYCStatus
                    formType={FORM_TYPE.BusinessPrime}
                    onAllKYCComplete={setAllKYCComplete}
                    applicationId={applicationForm?.plus_id}
                    allKYCComplete={allKYCComplete}
                />
            </> : <>
                <div style={{ fontSize: "30px", lineHeight: 2, marginBottom: 10 }}>
                    Thank you for submitting your application.
                </div>
                <div style={{ textAlign: "center", fontSize: "20px" }}>
                    {("Thank you for providing the information. We will be in touch with you shortly. We appreciate your interest in opening an account with us.")}
                </div>
            </>}
        </div>
    )
}

export default ThankYou